import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LastTimeRealTimeInfoComponent } from './last-time-real-time-info.component';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [LastTimeRealTimeInfoComponent],
  exports: [LastTimeRealTimeInfoComponent],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule
  ]
})
export class LastTimeRealTimeInfoModule { }
